import { render, staticRenderFns } from "./price-channels.vue?vue&type=template&id=3a19c7a8&scoped=true&"
import script from "./price-channels.vue?vue&type=script&lang=js&"
export * from "./price-channels.vue?vue&type=script&lang=js&"
import style0 from "./price-channels.vue?vue&type=style&index=0&id=3a19c7a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a19c7a8",
  null
  
)

export default component.exports